(function () {
	'use strict';

	angular.module('qbePortal').controller('AddressSearchController', AddressSearchController);

	AddressSearchController.$inject = ['$state', '$scope', 'serviceResponseRepository', 'quoteModelFactory', '$timeout', '$q', 'guideWireService'];

	function AddressSearchController($state, $scope, serviceResponseRepository, quoteModelFactory, $timeout, $q, guideWireService) {
		var vm = this;

		vm.$onInit = function () {
			if (!vm.name) {
				vm.name = 'address';
			}

			var name = $state.current.name;
			vm.addressResponses = [];
			vm.isSearchInProgress = false;
			if (name === 'bike.bike') {
				vm.messageAddressNotFound = 'Can’t find your address? Call us on 1800 24 34 64.';
			} else {
				vm.messageAddressNotFound = 'Can’t find your address? Call us on 133 723.';
			}

			vm.addressFound = true;

			if (vm.address !== null) {
				vm.addressInput = vm.address;
			}

			if (vm.addressType) {
				if (vm.address && !vm.address.addressType) {
					vm.address.addressType = vm.addressType;
					vm.update({
						name: 'address',
						value: vm.address
					});
				}
			}
		}

		$scope.$watch(vm.addressResponse);

		vm.refreshAddresses = function (viewValue) {
			vm.isSearchInProgress = true;
			return guideWireService.addressSearch({
				search: viewValue,
				type: 'physical'
			}).then(function (resp) {
				vm.isSearchInProgress = false;

				if (!!resp.data && resp.data.length <= 0) {
					vm.addressFound = false;
					return null;
				} else {
					vm.addressFound = true;
					return resp.data.map(function (item) {
						vm.addressResponse = item;
						return item;
					});
				}
			}).catch(function (resp) {
				vm.isSearchInProgress = false;
			});
		}

		// on selection of address
		vm.onSelect = function ($item, $model, $label) {
			if (vm.addressType)
				$model.addressType = vm.addressType;

			vm.update({
				name: vm.name,
				value: $model
			});

			//called with a timer to delay the validation
			$timeout(function () {
				$scope.$broadcast('type-ahead-value-received');
				if (vm.enrich == 'true') {
					$scope.$root.$broadcast('enrich-address');
				}
			}, 1000);

			if (vm.serviceName) {
				serviceResponseRepository.update(vm.serviceName, $model);
			}
		};

		vm.isAddressValid = function () {
			if (vm.addressResponse) {
				//check for the address line 1 in the addressResponse
				if (!!vm.addressResponse.addressLine1) {
					return true;
				} else {
					return false;
				}
			} else {
				//validates only if the not blank, blank is validated by the required
				return false;
			}
		}

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({
				name: name,
				setHierarchyFn: setHierarchyFn
			});
		}

	};

	angular.module('qbePortal').component('addressSearch', {
		templateUrl: '/ngviews/components/qbAddressSearch.html',
		controller: AddressSearchController,
		controllerAs: 'vm',
		bindings: {
			fieldKey: '@',
			validationSelector: '@',
			update: '&',
			setHierarchy: '&',
			labelKey: '@',
			address: '<?',
			labelWildcard: '<',
			enrich: '@?',
			name: '@?',
			serviceName: '@?',
			/** name under which the service
			 * response is captured.  To differentiate differet primary and secondary addresses
			 */
			addressType: '@?',
			/**
			 * type of address.  residential/postal and etc.
			 */
		}
	});

})();
